import { makeStyles } from '@material-ui/core/styles'

const footerStyle = makeStyles(() => ({
  footerBox: {
    backgroundColor: '#F7F7F7',
    color: '#777777',
    padding: '10px 20px',
    textAlign: 'right',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
    fontSize: '13px',
    position: 'absolute',
    bottom: '0',
    right: '0',
    width: '100%',
    zIndex: '100',
  },
  footerText: {
    margin: '0',
  },
  footerLink: {
    color: '#777777',
    textDecoration: 'none',
  },
}))

export { footerStyle }
